import Vue from 'vue'
import Vuex from 'vuex'
// import custom pathify config (this is optional!)
import pathify from './pathify'

// import helper function
import { make } from 'vuex-pathify'

// setup store
const state = {
  update_profilebot: {},
  picturegroup: '',
  groupname: '',
  tokenmsgforward: [],
  myname: '',
  myprofilepicture: '',
  mystatus: '',
  mybusiness_id: '',
  chIsactive: '',
  block_friend: {},
  pathsettings: '',
  socketmessage: null,
  socketquickreply: {},
  socketdisablequickreply: {},
  socketdisableapprove: {},
  socketnote: {},
  socketblock: {},
  socketfriend: {},
  socketaccept_friend: {},
  socketremove_request_friend: {},
  socketremove_friend: {},
  socketcreate_group: {},
  socketinvite_group: {},
  socketactive_group: {},
  socketcencel_group: {},
  socketleave_group: {},
  socketupdate_self: {},
  socketupdate_friend: {},
  socketupdate_img: {},
  socketupdate_file: {},
  socketmarkread: {},
  socket_unsendmessage: {},
  socket_register_event: {},
  socket_kickmember: {},
  socket_official_status: {},
  typeAgoraCall: {},
  socket_accept_call: {},
  socket_update_agora: {},
  themechat: {},
  count_request: 0,
  count_read: 0,
  socket_switch_richmenu: {},
  socket_switch_keyboard: {},
  socket_drop_menu: {},
  message_read: [],
}

const mutations = make.mutations(state)
// use store
Vue.use(Vuex)

// create store
export default new Vuex.Store({

  // use the plugin
  plugins: [
    pathify.plugin
  ],

  // store properties
  state,
  mutations
})
